import script from "./OutputDataDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./OutputDataDialog.vue?vue&type=script&setup=true&lang=ts"

import "./OutputDataDialog.vue?vue&type=style&index=0&id=47910c90&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47910c90"]])

export default __exports__